import { Box, Flex, Heading, Stack, Text } from "@chakra-ui/react";
import { FC } from "react";
import { Control, FieldValues, UseFormWatch } from "react-hook-form";
import { borderRadius, borderStyle } from "../../../../utils/styles/styles";
import FormSelect from "../../../../components/molecule/Select/FormSelect";
import NumberInputFieldComponent from "../../../../components/molecule/NumberInputField/NumberInputFieldComponent";
import { getSymbol } from "../../../../services/Indicator/getSymbol";

interface IndicatorReferencesFormProps {
  errors: any;
  control: Control<any>;
  isDisabled?: boolean;
  watch: UseFormWatch<FieldValues>;
  selectedIndicatorMetric: string;
  selectedHealthyLevel: string;
  selectedUnhealthyLevel: string;
}

const IndicatorReferencesForm: FC<IndicatorReferencesFormProps> = ({
  errors,
  control,
  isDisabled,
  watch,
  selectedIndicatorMetric,
  selectedHealthyLevel,
  selectedUnhealthyLevel,
}) => {
  return (
    <Stack
      spacing={4}
      border={borderStyle}
      borderRadius={borderRadius}
      background="gray.50"
      p={6}
    >
      <Heading as="h3" fontSize="2xl">
        Referenciais do indicador
      </Heading>
      <Flex gap={2} direction="column">
        <Text fontWeight="bold">Nível Saudável</Text>
        <Flex gap="4" alignItems="flex-start">
          <Box>
            <FormSelect
              control={control}
              errors={errors}
              watch={watch}
              fieldName="healthyLevelOption"
              fieldLabel="Critério"
              fetchOptions={getSymbol}
              isDisabled={isDisabled}
              isRequiredCondition={() => false}
            />
          </Box>
          {selectedHealthyLevel === "4" && (
            <Box>
              <NumberInputFieldComponent
                label="De"
                name="healthyIntervalFrom"
                errors={errors}
                isDisabled={isDisabled}
                control={control}
              />
            </Box>
          )}
          <Box>
            <NumberInputFieldComponent
              label="Valor"
              name="healthyIntervalTo"
              errors={errors}
              isDisabled={isDisabled}
              extraText={selectedIndicatorMetric}
              control={control}
            />
          </Box>
        </Flex>
      </Flex>
      <Flex gap={2} direction="column">
        <Text fontWeight="bold">Nível Não Saudável</Text>
        <Flex gap="4" alignItems="flex-start">
          <Box>
            <FormSelect
              control={control}
              errors={errors}
              watch={watch}
              fieldName="unhealthyLevelOption"
              fieldLabel="Critério"
              fetchOptions={getSymbol}
              isDisabled={isDisabled}
              isRequiredCondition={() => false}
            />
          </Box>
          {selectedUnhealthyLevel === "4" && (
            <Box>
              <NumberInputFieldComponent
                label="De"
                name="unhealthyIntervalFrom"
                errors={errors}
                isDisabled={isDisabled}
                control={control}
              />
            </Box>
          )}
          <Box>
            <NumberInputFieldComponent
              label="Valor"
              name="unhealthyIntervalTo"
              errors={errors}
              isDisabled={isDisabled}
              extraText={selectedIndicatorMetric}
              control={control}
            />
          </Box>
        </Flex>
      </Flex>
    </Stack>
  );
};

export default IndicatorReferencesForm;
